import { render, staticRenderFns } from "./club-pricing.vue?vue&type=template&id=bb4f4516"
import script from "./club-pricing.vue?vue&type=script&lang=ts"
export * from "./club-pricing.vue?vue&type=script&lang=ts"
import style0 from "./club-pricing.vue?vue&type=style&index=0&id=bb4f4516&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports